import { render, staticRenderFns } from "./LabelledResourceInstanceInput.vue?vue&type=template&id=5e01a6cf&"
import script from "./LabelledResourceInstanceInput.vue?vue&type=script&lang=js&"
export * from "./LabelledResourceInstanceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports